import React, {ReactNode} from "react";
import DeleteDialog from "./components/document/DeleteDialog";
import RenameDialog from "./components/document/RenameDialog";
import PrintDialog from "./components/document/PrintDialog";
import RotateDialog from "./components/page/RotateDialog";
import DeletePageDialog from "./components/page/DeletePageDialog";
import SplitDialog from "./components/page/SplitDialog";
import WatermarkDialog from "./components/page/WatermarkDialog";
import GlobalAttachmentDialog from "./components/attachment/GlobalAttachmentDialog";
import AttachmentDialog from "./components/attachment/AttachmentDialog";
import ContentExtractionDialog from "./components/export/ContentExtractionDialog";
import ImageExtractionDialog from "./components/export/ImageExtractionDialog";
import InfoExtractionDialog from "./components/export/InfoExtractionDialog";
import PageExtractionDialog from "./components/export/PageExtractionDialog";
import BackgroundDialog from "./components/page/BackgroundDialog";
import HeaderFooterDialog from "./components/page/HeaderFooterDialog";
import BoxesDialog from "./components/page/BoxesDialog";
import TransitionDialog from "./components/page/TransitionDialog";
import PageAddDialog from "./components/page/PageAddDialog";
import ConvertDialog from "./components/convert/ConvertDialog";
import PdfaDialog from "./components/convert/PdfaDialog";
import OcrDialog from "./components/convert/OcrDialog";
import SignatureDialog from "./components/signature/SignatureDialog";
import FormsFlattenDialog from "./components/forms/FormsFlattenDialog";
import FormsExtractionDialog from "./components/forms/FormsExtractionDialog";
import FormsImportDialog from "./components/forms/FormsImportDialog";
import SanitizeDialog from "./components/document/SanitizeDialog";
import RedactPageDialog from "./components/redact/RedactPageDialog";
import RedactDialog from "./components/redact/RedactDialog";
import BarcodeCreateAreaDialog from "./components/barcode/BarcodeCreateAreaDialog";
import BarcodeDetectDialog from "./components/barcode/BarcodeDetectDialog";
import PortfolioCreateDialog from "./components/portfolio/PortfolioCreateDialog";
import Parameter from "./parameter/Parameter";
import {PortalGlobals} from "../Portal";
import UploadDialog from "./components/document/UploadDialog";
import MergeDialog from "./components/document/MergeDialog";
import {DropzoneGlobals} from "../startscreen/Dropzone";
import DescriptionDialog from "./components/document/DescriptionDialog";
import ViewDialog from "./components/document/ViewDialog";
import EncryptDialog from "./components/security/EncryptDialog";
import DecryptDialog from "./components/security/DecryptDialog";
import OutlineAddDialog from "./components/document/OutlineAddDialog";
import {PortalDocumentManagerGlobals} from "../document/PortalDocumentManager";
import {I18nGlobals} from "../../shared/translation/i18nInterface";
import PortfolioRemoveDialog from "./components/portfolio/PortfolioRemoveDialog";
import UrlConverterDialogDefinition from "./components/document/UrlConverterDialog";
import PasswordDialog from "./components/security/PasswordDialog";
import CertificateEncryptDialog from "./components/security/CertificateEncryptDialog";
import {MessageGlobals} from "../../shared/log/MessageInterface";
import Dialogs, {DialogsGlobals} from "../../shared/dialog/components/Dialogs";
import BarcodeCreateDialog from "./components/barcode/BarcodeCreateDialog";
import BarcodeCreateSwissQrCodeDialog from "./components/barcode/BarcodeCreateSwissQrCodeDialog";
import {DeleteDocumentType} from "../../shared/models/DeleteDocumentType";
import {PortalPagesAdd} from "../../shared/models/PortalPagesAdd";
import CompressionDialog from "./components/document/CompressionDialog";
import BarcodeCreateSwissQrCodeAreaDialog from "./components/barcode/BarcodeCreateSwissQrCodeAreaDialog";
import ScaleDialog from "./components/page/ScaleDialog";
import {
	Signature,
	ToolboxAnnotationAnnotation,
	ToolboxAttachmentAttachment,
	ToolboxCompressCompress,
	ToolboxDeleteDelete,
	ToolboxDescriptionDescription,
	ToolboxFormsForms,
	ToolboxOptionsOptions,
	ToolboxOutlineOutline,
	ToolboxPrintPrint,
	ToolboxRedactRedact,
	ToolboxRotateRotate,
	ToolboxScaleScale,
	ToolboxSecuritySecurity,
	ToolboxSplitSplit,
	ToolboxTranscribeTranscribe
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {PortalToolboxMergeMerge} from "../../shared/models/PortalToolboxMergeMerge";
import {PortalRename} from "../../shared/models/PortalRename";
import {PortalToolboxWatermarkWatermark} from "../../shared/models/PortalToolboxWatermarkWatermark";
import {PortalToolboxExtractionExtraction} from "../../shared/models/PortalToolboxExtractionExtraction";
import {PortalToolboxImageImage} from "../../shared/models/PortalToolboxImageImage";
import {PortalToolboxSplitSplit} from "../../shared/models/PortalToolboxSplitSplit";
import {PortalToolboxOptionsOptions} from "../../shared/models/PortalToolboxOptionsOptions";
import {PortalConverter} from "../../shared/models/PortalConverter";
import {PortalPdfa} from "../../shared/models/PortalPdfa";
import {PortalOcr} from "../../shared/models/PortalOcr";
import {PortalBarcode} from "../../shared/models/PortalBarcode";
import {PortalToolboxPortfolioPortfolio} from "../../shared/models/PortalToolboxPortfolioPortfolio";
import HtmlExtractionDialog from "./components/export/HtmlExtractionDialog";
import OrientationDialog from "./components/page/OrientationDialog";
import {HelperGlobals} from "../../shared/components/Helper";
import {PortalSignature} from "../../shared/models/PortalSignature";
import DeleteAnnotationDialog from "./components/annotation/DeleteAnnotationDialog";
import AnnotationMarkEditDialog from "./components/annotation/AnnotationMarkEditDialog";
import AnnotationNoteEditDialog from "./components/annotation/AnnotationNoteEditDialog";
import AnnotationStrikeEditDialog from "./components/annotation/AnnotationStrikeEditDialog";
import AnnotationUnderlineEditDialog from "./components/annotation/AnnotationUnderlineEditDialog";
import AnnotationSquigglyEditDialog from "./components/annotation/AnnotationSquigglyEditDialog";
import AnnotationLineEditDialog from "./components/annotation/AnnotationLineEditDialog";
import AnnotationSquareEditDialog from "./components/annotation/AnnotationSquareEditDialog";
import AnnotationCircleEditDialog from "./components/annotation/AnnotationCircleEditDialog";
import RedactEditDialog from "./components/redact/RedactEditDialog";
import AnnotationFlattenDialog from "./components/annotation/AnnotationFlattenDialog";
import AnnotationReplyEditDialog from "./components/annotation/AnnotationReplyEditDialog";
import AnnotationStampEditDialog from "./components/annotation/AnnotationStampEditDialog";
import CertificateSettingsDialog from "./components/settings/CertificateSettingsDialog";
import DebugDialog, {DebugGlobals} from "./components/settings/DebugDialog";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import SignatureRemoveDialog from "./components/signature/SignatureRemoveDialog";
import PortfolioAddFolderDialog from "./components/portfolio/PortfolioAddFolderDialog";
import PortfolioAddFileDialog from "./components/portfolio/PortfolioAddFileDialog";
import PortalPureComponent from "../../shared/components/PortalPureComponent";

export interface PortalDialogsGlobals extends DialogsGlobals {
	showUploadDialog?: boolean;
	uploadFiles?: FileList;
	showMergeDialog?: boolean;
	mergeParameter?: Parameter<PortalToolboxMergeMerge>;
	showDeleteDialog?: boolean;
	deleteParameter?: Parameter<DeleteDocumentType>;
	showRenameDialog?: boolean;
	renameParameter?: Parameter<PortalRename>;
	showPrintDialog?: boolean;
	printParameter?: Parameter<ToolboxPrintPrint>;
	showRotateDialog?: boolean;
	rotateParameter?: Parameter<ToolboxRotateRotate>;
	showOrientationDialog?: boolean;
	orientationParameter?: Parameter<ToolboxRotateRotate>;
	showDeletePageDialog?: boolean;
	deletePageParameter?: Parameter<ToolboxDeleteDelete>;
	showSplitDialog?: boolean;
	splitParameter?: Parameter<ToolboxSplitSplit>;
	showWatermarkDialog?: boolean;
	watermarkParameter?: Parameter<PortalToolboxWatermarkWatermark>;
	showAttachmentDialog?: boolean;
	attachmentParameter?: Parameter<ToolboxAttachmentAttachment>;
	showGlobalAttachmentDialog?: boolean;
	globalAttachmentParameter?: Parameter<ToolboxAttachmentAttachment>;
	showContentExtractionDialog?: boolean;
	contentExtractionParameter?: Parameter<PortalToolboxExtractionExtraction>;
	showImageExtractionDialog?: boolean;
	imageExtractionParameter?: Parameter<PortalToolboxImageImage>;
	showInfoExtractionDialog?: boolean;
	infoExtractionParameter?: Parameter<PortalToolboxExtractionExtraction>;
	showPageExtractionDialog?: boolean;
	pageExtractionParameter?: Parameter<PortalToolboxSplitSplit>;
	showBackgroundDialog?: boolean;
	backgroundParameter?: Parameter<PortalToolboxOptionsOptions>;
	showHeaderFooterDialog?: boolean;
	headerFooterParameter?: Parameter<PortalToolboxOptionsOptions>;
	showBoxesDialog?: boolean;
	boxesParameter?: Parameter<PortalToolboxOptionsOptions>;
	showTransitionDialog?: boolean;
	transitionParameter?: Parameter<PortalToolboxOptionsOptions>;
	showAddPageDialog?: boolean;
	addPageParameter?: Parameter<PortalPagesAdd>;
	showConvertDialog?: boolean;
	convertParameter?: Parameter<PortalConverter>;
	showPdfaDialog?: boolean;
	pdfaParameter?: Parameter<PortalPdfa>;
	showOcrDialog?: boolean;
	ocrParameter?: Parameter<PortalOcr>;
	showSignatureDialog?: boolean;
	signatureParameter?: Parameter<PortalSignature>;
	showSignatureRemoveDialog?: boolean;
	signatureRemoveParameter?: Parameter<Signature>;
	showDeleteFormsDialog?: boolean;
	deleteFormsParameter?: Parameter<ToolboxFormsForms>;
	showFormExtractionDialog?: boolean;
	formExtractionParameter?: Parameter<ToolboxFormsForms>;
	showFormImportDialog?: boolean;
	formImportParameter?: Parameter<ToolboxFormsForms>;
	showSanitizeDialog?: boolean;
	sanitizeParameter?: Parameter<ToolboxRedactRedact>;
	showRedactPageDialog?: boolean;
	redactPageParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showRedactDialog?: boolean;
	redactParameter?: Parameter<ToolboxRedactRedact>;
	showBarcodeCreateAreaDialog?: boolean;
	barcodeCreateAreaParameter?: Parameter<PortalBarcode>;
	showBarcodeCreateSwissQrAreaDialog?: boolean;
	barcodeCreateSwissQrAreaParameter?: Parameter<PortalBarcode>;
	showBarcodeCreateDialog?: boolean;
	barcodeCreateParameter?: Parameter<PortalBarcode>;
	showBarcodeSwissDialog?: boolean;
	barcodeSwissParameter?: Parameter<PortalBarcode>;
	showBarcodeDetectDialog?: boolean;
	barcodeDetectParameter?: Parameter<PortalBarcode>;
	showAnnotationNoteEditDialog?: boolean;
	annotationNoteEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationMarkEditDialog?: boolean;
	annotationMarkEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationUnderlineEditDialog?: boolean;
	annotationUnderlineEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationSquigglyEditDialog?: boolean;
	annotationSquigglyEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationStrikeEditDialog?: boolean;
	annotationStrikeEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationLineEditDialog?: boolean;
	annotationLineEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationSquareEditDialog?: boolean;
	annotationSquareEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationCircleEditDialog?: boolean;
	annotationCircleEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showPortfolioCreateDialog?: boolean;
	portfolioCreateParameter?: Parameter<PortalToolboxPortfolioPortfolio>;
	showPortfolioAddFileDialog?: boolean;
	portfolioAddFileParameter?: Parameter<PortalToolboxPortfolioPortfolio>;
	showPortfolioAddFolderDialog?: boolean;
	portfolioAddFolderParameter?: Parameter<PortalToolboxPortfolioPortfolio>;
	showPortfolioRemoveDialog?: boolean;
	portfolioRemoveParameter?: Parameter<PortalToolboxPortfolioPortfolio>;
	showDescriptionDialog?: boolean;
	descriptionParameter?: Parameter<ToolboxDescriptionDescription>;
	showViewDialog?: boolean;
	viewParameter?: Parameter<ToolboxOptionsOptions>;
	showEncryptDialog?: boolean;
	encryptParameter?: Parameter<ToolboxSecuritySecurity>;
	showCertificateEncryptDialog?: boolean;
	certificateEncryptParameter?: Parameter<ToolboxSecuritySecurity>;
	showDecryptDialog?: boolean;
	decryptParameter?: Parameter<ToolboxSecuritySecurity>;
	showOutlineAddDialog?: boolean;
	outlineAddParameter?: Parameter<ToolboxOutlineOutline>;
	showUrlConverterDialog?: boolean;
	showPasswordDialog?: boolean;
	passwordRecallFunction?: () => Promise<void>;
	showCompressionDialog?: boolean;
	compressionParameter?: Parameter<ToolboxCompressCompress>;
	showScaleDialog?: boolean;
	scaleParameter?: Parameter<ToolboxScaleScale>;
	showHtmlExtractionDialog?: boolean;
	htmlExtractionParameter?: Parameter<ToolboxTranscribeTranscribe>;
	showDeleteAnnotationDialog?: boolean;
	deleteAnnotationParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showRedactEditDialog?: boolean;
	redactEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationFlattenDialog?: boolean;
	annotationFlattenParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationReplyEditDialog?: boolean;
	annotationReplyEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationStampEditDialog?: boolean;
	annotationStampEditParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showCertificateSettingsDialog?: boolean;
	showDebugDialog?: boolean;
}

interface PortalDialogsProperties extends PortalDialogsGlobals, MessageGlobals, PortalGlobals, I18nGlobals,
	PortalDocumentManagerGlobals, DropzoneGlobals, HelperGlobals, DebugGlobals {
}

export default class PortalDialogs extends PortalPureComponent<PortalDialogsProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let isReconnecting: boolean = FunctionHelper.applyValue(this.props.showReconnectDialog, false);

		return (
			<>
				{!isReconnecting &&
					<>
						<UploadDialog {...this.props}
									  visible={FunctionHelper.applyValue(this.props.showUploadDialog, false)}
									  hide={() => this.props.context.getPage().setState({showUploadDialog: false})}
									  uploadFiles={this.props.uploadFiles}/>
						<MergeDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showMergeDialog, false)}
									 hide={() => this.props.context.getPage().setState({showMergeDialog: false})}
									 parameter={this.props.mergeParameter}/>
						<DeleteDialog {...this.props}
									  visible={FunctionHelper.applyValue(this.props.showDeleteDialog, false)}
									  hide={() => this.props.context.getPage().setState({showDeleteDialog: false})}
									  parameter={this.props.deleteParameter}/>
						<RenameDialog {...this.props}
									  visible={FunctionHelper.applyValue(this.props.showRenameDialog, false)}
									  hide={() => this.props.context.getPage().setState({showRenameDialog: false})}
									  parameter={this.props.renameParameter}/>
						<PrintDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showPrintDialog, false)}
									 hide={() => this.props.context.getPage().setState({showPrintDialog: false})}
									 parameter={this.props.printParameter}/>
						<RotateDialog {...this.props}
									  visible={FunctionHelper.applyValue(this.props.showRotateDialog, false)}
									  hide={() => this.props.context.getPage().setState({showRotateDialog: false})}
									  parameter={this.props.rotateParameter}/>
						<OrientationDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showOrientationDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showOrientationDialog: false
										   })} parameter={this.props.orientationParameter}/>
						<DeletePageDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showDeletePageDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showDeletePageDialog: false
										  })}
										  parameter={this.props.deletePageParameter}/>
						<SplitDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showSplitDialog, false)}
									 hide={() => this.props.context.getPage().setState({showSplitDialog: false})}
									 parameter={this.props.splitParameter}/>
						<WatermarkDialog {...this.props}
										 visible={FunctionHelper.applyValue(
											 this.props.showWatermarkDialog, false
										 )}
										 hide={() => this.props.context.getPage().setState({
											 showWatermarkDialog: false
										 })}
										 parameter={this.props.watermarkParameter}/>
						<GlobalAttachmentDialog {...this.props}
												visible={FunctionHelper.applyValue(
													this.props.showGlobalAttachmentDialog, false
												)}
												hide={() => this.props.context.getPage().setState({
													showGlobalAttachmentDialog: false
												})}
												parameter={this.props.globalAttachmentParameter}/>
						<AttachmentDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showAttachmentDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showAttachmentDialog: false
										  })}
										  parameter={this.props.attachmentParameter}/>
						<ContentExtractionDialog {...this.props}
												 visible={FunctionHelper.applyValue(
													 this.props.showContentExtractionDialog, false
												 )}
												 hide={() => this.props.context.getPage().setState({
													 showContentExtractionDialog: false
												 })}
												 parameter={this.props.contentExtractionParameter}/>
						<ImageExtractionDialog {...this.props}
											   visible={FunctionHelper.applyValue(
												   this.props.showImageExtractionDialog, false
											   )}
											   hide={() => this.props.context.getPage().setState({
												   showImageExtractionDialog: false
											   })}
											   parameter={this.props.imageExtractionParameter}/>
						<InfoExtractionDialog {...this.props}
											  visible={FunctionHelper.applyValue(
												  this.props.showInfoExtractionDialog, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showInfoExtractionDialog: false
											  })}
											  parameter={this.props.infoExtractionParameter}/>
						<PageExtractionDialog {...this.props}
											  visible={FunctionHelper.applyValue(
												  this.props.showPageExtractionDialog, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showPageExtractionDialog: false
											  })}
											  parameter={this.props.pageExtractionParameter}/>
						<BackgroundDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showBackgroundDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showBackgroundDialog: false
										  })}
										  parameter={this.props.backgroundParameter}/>
						<HeaderFooterDialog {...this.props}
											visible={FunctionHelper.applyValue(
												this.props.showHeaderFooterDialog, false
											)}
											hide={() => this.props.context.getPage().setState({
												showHeaderFooterDialog: false
											})}
											parameter={this.props.headerFooterParameter}/>
						<BoxesDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showBoxesDialog, false)}
									 hide={() => this.props.context.getPage().setState({showBoxesDialog: false})}
									 parameter={this.props.boxesParameter}/>
						<TransitionDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showTransitionDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showTransitionDialog: false
										  })}
										  parameter={this.props.transitionParameter}/>
						<PageAddDialog {...this.props}
									   visible={FunctionHelper.applyValue(
										   this.props.showAddPageDialog, false
									   )}
									   hide={() => this.props.context.getPage().setState({
										   showAddPageDialog: false
									   })}
									   parameter={this.props.addPageParameter}/>
						<ConvertDialog {...this.props}
									   visible={FunctionHelper.applyValue(
										   this.props.showConvertDialog, false
									   )}
									   hide={() => this.props.context.getPage().setState({
										   showConvertDialog: false
									   })}
									   parameter={this.props.convertParameter}/>
						<PdfaDialog {...this.props}
									visible={FunctionHelper.applyValue(this.props.showPdfaDialog, false)}
									hide={() => this.props.context.getPage().setState({showPdfaDialog: false})}
									parameter={this.props.pdfaParameter}/>
						<OcrDialog {...this.props}
								   visible={FunctionHelper.applyValue(this.props.showOcrDialog, false)}
								   hide={() => this.props.context.getPage().setState({showOcrDialog: false})}
								   parameter={this.props.ocrParameter}/>
						<SignatureDialog {...this.props}
										 visible={FunctionHelper.applyValue(
											 this.props.showSignatureDialog, false
										 )}
										 hide={() => this.props.context.getPage().setState({
											 showSignatureDialog: false
										 })}
										 parameter={this.props.signatureParameter}/>
						<SignatureRemoveDialog {...this.props}
											   visible={FunctionHelper.applyValue(
												   this.props.showSignatureRemoveDialog, false
											   )}
											   hide={() => this.props.context.getPage().setState({
												   showSignatureRemoveDialog: false
											   })}
											   parameter={this.props.signatureRemoveParameter}/>
						<FormsFlattenDialog {...this.props}
											visible={FunctionHelper.applyValue(
												this.props.showDeleteFormsDialog, false
											)}
											hide={() => this.props.context.getPage().setState({
												showDeleteFormsDialog: false
											})}
											parameter={this.props.deleteFormsParameter}/>
						<FormsExtractionDialog {...this.props}
											   visible={FunctionHelper.applyValue(
												   this.props.showFormExtractionDialog, false
											   )}
											   hide={() => this.props.context.getPage().setState({
												   showFormExtractionDialog: false
											   })}
											   parameter={this.props.formExtractionParameter}/>
						<FormsImportDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showFormImportDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showFormImportDialog: false
										   })}
										   parameter={this.props.formImportParameter}/>
						<SanitizeDialog {...this.props}
										visible={FunctionHelper.applyValue(
											this.props.showSanitizeDialog, false
										)}
										hide={() => this.props.context.getPage().setState({
											showSanitizeDialog: false
										})}
										parameter={this.props.sanitizeParameter}/>
						<RedactPageDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showRedactPageDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showRedactPageDialog: false
										  })}
										  parameter={this.props.redactPageParameter}/>
						<RedactDialog {...this.props}
									  visible={FunctionHelper.applyValue(this.props.showRedactDialog, false)}
									  hide={() => this.props.context.getPage().setState({showRedactDialog: false})}
									  parameter={this.props.redactParameter}/>
						<RedactEditDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showRedactEditDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showRedactEditDialog: false
										  })}
										  parameter={this.props.redactEditParameter}/>
						<BarcodeCreateSwissQrCodeDialog {...this.props}
														visible={FunctionHelper.applyValue(
															this.props.showBarcodeSwissDialog, false
														)}
														hide={() => this.props.context.getPage().setState({
															showBarcodeSwissDialog: false
														})}
														parameter={this.props.barcodeSwissParameter}/>
						<BarcodeCreateAreaDialog {...this.props}
												 visible={FunctionHelper.applyValue(
													 this.props.showBarcodeCreateAreaDialog, false
												 )}
												 hide={() => this.props.context.getPage().setState({
													 showBarcodeCreateAreaDialog: false
												 })}
												 parameter={this.props.barcodeCreateAreaParameter}/>
						<BarcodeCreateSwissQrCodeAreaDialog {...this.props}
															visible={FunctionHelper.applyValue(
																this.props.showBarcodeCreateSwissQrAreaDialog,
																false
															)}
															hide={() => this.props.context.getPage().setState(
																{showBarcodeCreateSwissQrAreaDialog: false}
															)}
															parameter={this.props.barcodeCreateSwissQrAreaParameter}/>
						<BarcodeCreateDialog {...this.props}
											 visible={FunctionHelper.applyValue(
												 this.props.showBarcodeCreateDialog, false
											 )}
											 hide={() => this.props.context.getPage().setState({
												 showBarcodeCreateDialog: false
											 })}
											 parameter={this.props.barcodeCreateParameter}/>
						<BarcodeDetectDialog {...this.props}
											 visible={FunctionHelper.applyValue(
												 this.props.showBarcodeDetectDialog, false
											 )}
											 hide={() => this.props.context.getPage().setState({
												 showBarcodeDetectDialog: false
											 })}
											 parameter={this.props.barcodeDetectParameter}/>
						<AnnotationNoteEditDialog {...this.props}
												  visible={FunctionHelper.applyValue(
													  this.props.showAnnotationNoteEditDialog, false
												  )}
												  hide={() => this.props.context.getPage().setState({
													  showAnnotationNoteEditDialog: false
												  })}
												  parameter={this.props.annotationNoteEditParameter}/>
						<AnnotationMarkEditDialog {...this.props}
												  visible={FunctionHelper.applyValue(
													  this.props.showAnnotationMarkEditDialog, false
												  )}
												  hide={() => this.props.context.getPage().setState({
													  showAnnotationMarkEditDialog: false
												  })}
												  parameter={this.props.annotationMarkEditParameter}/>
						<AnnotationUnderlineEditDialog {...this.props}
													   visible={FunctionHelper.applyValue(
														   this.props.showAnnotationUnderlineEditDialog,
														   false
													   )}
													   hide={() => this.props.context.getPage().setState({
														   showAnnotationUnderlineEditDialog: false
													   })}
													   parameter={this.props.annotationUnderlineEditParameter}/>
						<AnnotationSquigglyEditDialog {...this.props}
													  visible={FunctionHelper.applyValue(
														  this.props.showAnnotationSquigglyEditDialog, false
													  )}
													  hide={() => this.props.context.getPage().setState({
														  showAnnotationSquigglyEditDialog: false
													  })}
													  parameter={this.props.annotationSquigglyEditParameter}/>
						<AnnotationStrikeEditDialog {...this.props}
													visible={FunctionHelper.applyValue(
														this.props.showAnnotationStrikeEditDialog, false
													)}
													hide={() => this.props.context.getPage().setState({
														showAnnotationStrikeEditDialog: false
													})}
													parameter={this.props.annotationStrikeEditParameter}/>
						<AnnotationLineEditDialog {...this.props}
												  visible={FunctionHelper.applyValue(
													  this.props.showAnnotationLineEditDialog, false
												  )}
												  hide={() => this.props.context.getPage().setState({
													  showAnnotationLineEditDialog: false
												  })}
												  parameter={this.props.annotationLineEditParameter}/>
						<AnnotationSquareEditDialog {...this.props}
													visible={FunctionHelper.applyValue(
														this.props.showAnnotationSquareEditDialog, false
													)}
													hide={() => this.props.context.getPage().setState({
														showAnnotationSquareEditDialog: false
													})}
													parameter={this.props.annotationSquareEditParameter}/>
						<AnnotationCircleEditDialog {...this.props}
													visible={FunctionHelper.applyValue(
														this.props.showAnnotationCircleEditDialog, false
													)}
													hide={() => this.props.context.getPage().setState({
														showAnnotationCircleEditDialog: false
													})}
													parameter={this.props.annotationCircleEditParameter}/>
						<PortfolioCreateDialog {...this.props}
											   visible={FunctionHelper.applyValue(
												   this.props.showPortfolioCreateDialog, false
											   )}
											   hide={() => this.props.context.getPage().setState({
												   showPortfolioCreateDialog: false
											   })}
											   parameter={this.props.portfolioCreateParameter}/>
						<PortfolioAddFileDialog {...this.props}
												visible={FunctionHelper.applyValue(
													this.props.showPortfolioAddFileDialog, false
												)}
												hide={() => this.props.context.getPage().setState({
													showPortfolioAddFileDialog: false
												})}
												parameter={this.props.portfolioAddFileParameter}/>
						<PortfolioAddFolderDialog {...this.props}
												  visible={FunctionHelper.applyValue(
													  this.props.showPortfolioAddFolderDialog, false
												  )}
												  hide={() => this.props.context.getPage().setState({
													  showPortfolioAddFolderDialog: false
												  })}
												  parameter={this.props.portfolioAddFolderParameter}/>
						<PortfolioRemoveDialog {...this.props}
											   visible={FunctionHelper.applyValue(
												   this.props.showPortfolioRemoveDialog, false
											   )}
											   hide={() => this.props.context.getPage().setState({
												   showPortfolioRemoveDialog: false
											   })}
											   parameter={this.props.portfolioRemoveParameter}/>
						<DescriptionDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showDescriptionDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showDescriptionDialog: false
										   })}
										   parameter={this.props.descriptionParameter}/>
						<ViewDialog {...this.props}
									visible={FunctionHelper.applyValue(this.props.showViewDialog, false)}
									hide={() => this.props.context.getPage().setState({showViewDialog: false})}
									parameter={this.props.viewParameter}/>
						<EncryptDialog {...this.props}
									   visible={FunctionHelper.applyValue(
										   this.props.showEncryptDialog, false
									   )}
									   hide={() => this.props.context.getPage().setState({
										   showEncryptDialog: false
									   })}
									   parameter={this.props.encryptParameter}/>
						<CertificateEncryptDialog {...this.props}
												  visible={FunctionHelper.applyValue(
													  this.props.showCertificateEncryptDialog, false
												  )}
												  hide={() => this.props.context.getPage().setState({
													  showCertificateEncryptDialog: false
												  })} parameter={this.props.certificateEncryptParameter}/>
						<DecryptDialog {...this.props}
									   visible={FunctionHelper.applyValue(
										   this.props.showDecryptDialog, false
									   )}
									   hide={() => this.props.context.getPage().setState({
										   showDecryptDialog: false
									   })}
									   parameter={this.props.decryptParameter}/>
						<OutlineAddDialog {...this.props}
										  visible={FunctionHelper.applyValue(
											  this.props.showOutlineAddDialog, false
										  )}
										  hide={() => this.props.context.getPage().setState({
											  showOutlineAddDialog: false
										  })}
										  parameter={this.props.outlineAddParameter}/>
						<UrlConverterDialogDefinition {...this.props}
													  visible={FunctionHelper.applyValue(
														  this.props.showUrlConverterDialog, false
													  )}
													  hide={() => this.props.context.getPage().setState({
														  showUrlConverterDialog: false
													  })}/>
						{this.props.showPasswordDialog &&
							<PasswordDialog {...this.props} visible={this.props.showPasswordDialog}
											close={() => this.props.context.getPage().setState({
												showPasswordDialog: false
											})}
											portalDocument={
												this.props.context.documentManager.getSelection()[0]
											}
											hide={async () => {
												if (FunctionHelper.exists(this.props.passwordRecallFunction)) {
													await this.props.passwordRecallFunction!();
												}

												this.props.context.getPage().setState({
													showPasswordDialog: false,
													passwordRecallFunction: undefined
												});
											}}/>
						}
						<CompressionDialog {...this.props}
										   visible={FunctionHelper.applyValue(
											   this.props.showCompressionDialog, false
										   )}
										   hide={() => this.props.context.getPage().setState({
											   showCompressionDialog: false
										   })}
										   parameter={this.props.compressionParameter}/>
						<ScaleDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showScaleDialog, false)}
									 hide={() =>
										 this.props.context.getPage().setState({showScaleDialog: false})
									 }
									 parameter={this.props.scaleParameter}/>
						<HtmlExtractionDialog {...this.props}
											  visible={FunctionHelper.applyValue(
												  this.props.showHtmlExtractionDialog, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showHtmlExtractionDialog: false
											  })}
											  parameter={this.props.htmlExtractionParameter}/>
						<DeleteAnnotationDialog {...this.props}
												visible={FunctionHelper.applyValue(
													this.props.showDeleteAnnotationDialog, false
												)}
												hide={() => this.props.context.getPage().setState({
													showDeleteAnnotationDialog: false
												})}
												parameter={this.props.deleteAnnotationParameter}/>
						<AnnotationFlattenDialog {...this.props}
												 visible={FunctionHelper.applyValue(
													 this.props.showAnnotationFlattenDialog, false
												 )}
												 hide={() => this.props.context.getPage().setState({
													 showAnnotationFlattenDialog: false
												 })}
												 parameter={this.props.annotationFlattenParameter}/>
						<AnnotationReplyEditDialog {...this.props}
												   visible={FunctionHelper.applyValue(
													   this.props.showAnnotationReplyEditDialog, false
												   )}
												   hide={() => this.props.context.getPage().setState({
													   showAnnotationReplyEditDialog: false
												   })}
												   parameter={this.props.annotationReplyEditParameter}/>
						<AnnotationStampEditDialog {...this.props}
												   visible={FunctionHelper.applyValue(
													   this.props.showAnnotationStampEditDialog, false
												   )}
												   hide={() => this.props.context.getPage().setState({
													   showAnnotationStampEditDialog: false
												   })}
												   parameter={this.props.annotationStampEditParameter}/>
						<CertificateSettingsDialog {...this.props}
												   visible={FunctionHelper.applyValue(
													   this.props.showCertificateSettingsDialog, false
												   )}
												   hide={() => this.props.context.getPage().setState({
													   showCertificateSettingsDialog: false
												   })}/>
						<DebugDialog {...this.props}
									 visible={FunctionHelper.applyValue(this.props.showDebugDialog, false)}
									 hide={() => this.props.context.getPage().setState({
										 showDebugDialog: false
									 })}/>
					</>
				}
				<Dialogs {...this.props}/>
			</>
		);
	}
}